import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/contains/Home'
import AboutUs from '@/components/contains/AboutUs'
import JoinUs from '@/components/contains/JoinUs'
import Service from '@/components/contains/Service'
import Production from '@/components/contains/Production'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/aboutUs',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/production',
      name: 'Production',
      component: Production
    },
    {
      path: '/service',
      name: 'Service',
      component: Service
    },
    {
      path: '/joinUs',
      name: 'JoinUs',
      component: JoinUs
    }
  ],
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    var scrollToTop = setInterval(function () {
      var pos = window.pageYOffset;

      if (pos > 0) {
        window.scrollTo(0, pos - 20);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 10);
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js